module.exports = __webpack_public_path__ + "static/img/tupian_ewm.db358ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tupian_ewm.png
// module id = 5+T2
// module chunks = 10